import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

import en from './assets/i18n/en';
import enGb from './assets/i18n/en-gb';
import es from './assets/i18n/es';
import fr from './assets/i18n/fr';
import de from './assets/i18n/de'
import nl from './assets/i18n/nl'


@Pipe({
  name: 'phxTranslate',
})
export class PhxTranslatePipe implements PipeTransform {
  public lang: string = 'en';
  public translations: any = en;

  constructor(private translocoService: TranslocoService) {
    this.lang = this.translocoService.getActiveLang() || 'en';
    this.setTranslationObject();
    this.translocoService.langChanges$.subscribe(lang => {
      this.lang = lang;
      this.setTranslationObject();
    });
  }

  public setTranslationObject(): void {
    if (this.lang === 'en') this.translations = en;
    if (this.lang === 'en-GB') this.translations = enGb;
    if (this.lang === 'es') this.translations = es;
    if (this.lang === 'fr') this.translations = fr;
    if (this.lang === 'nl') this.translations = nl;
    if (this.lang === 'de') this.translations = de;
  }

  transform(key: string, ...args): string {
    return this.translations?.[key] || key;
  }
}
